import React, { useRef, useState, useEffect, useContext } from "react";


import { useNavigate } from "react-router-dom";
import AuthService from "../../services/auth.service";

import axios from "axios";

import NuAlert2 from '../../components/NuAlert2';
import NuLoading from '../../components/nubox/NuLoading';
import userEvent from "@testing-library/user-event";

 //--- CONTEXT API -----------
 import { useStore, useDispatch } from "store/StoreProvider";
 import { types } from "store/StoreReducer";
import NuDropdown from "components/nubox/NuDropdown";

import logo0 from '../../assets/img/logo0.png'; 
import logo_horizontal from "assets/img/logo_horizontal.png";

const Login = () => {
  //---------------- CONTEXT API ------------------
  const store = useStore();
  const dispatch = useDispatch();
  //--------------------------------------------
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [arrPeriodo, setArrPeriodo] = useState([]); //Cbo
  const [itemSelected, setItemSelected] = useState({"value":0, "label":0 }); //Cbo
  const [form, setForm] = useState({}); //formulario
  
  const [cargando, setCargando] = useState(false);
  const nuRef = useRef(null);

  const navigate = useNavigate();

  //-- equivalente a componentDidMount
  //---si tiene token valido, tons lo redireccionamos a el /dashboard
  // Replaces componentDidMount
  useEffect( ()=>{
    //---si es que hay token nos vamos al dashboard
    if(AuthService.getLocalAccessToken()!=null){
      navigate("/login");
    }
    //-------
    cargar_form()
    cargar_periodo() //cargamos combo periodo
  }, []);
  //-------------------
  const handleChangePeri=(e)=>{
    console.log(e.target.item);
    setItemSelected(e.target.item)
  }
  //-----------------------------------------
  const cargar_form = () => {      

    let param = { 
      idd: 1,
      ope:'f'
    }
    console.log(param);
    axios.post( process.env.REACT_APP_API_URL  + "layout_web_cargar_globalx", param)
    .then(res => {
        console.log(res.data )
        if( res.data!==''){ 
            //añadimos el id y ope
            setForm(res.data)
            
        }else{
            //toast.error("Registro no encontrado", {
            //position: toast.POSITION.TOP_RIGHT
            //});
        }

    })
    .catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  };
  //---------------------------------
  const cargar_periodo = (id_est) => {      
    console.log("cbo_periodo");
    let param = { }

    axios.post( process.env.REACT_APP_API_URL  + "cbo_periodo", param)
    .then(res => {
        console.log(res.data);
        if( res.data!==''){ 
            //cargamos 
            setArrPeriodo(res.data);            
        }else{
          alert("Error cargando periodo");
        }
        //---marcamos el primero como seleccionado
        setItemSelected(res.data[0])

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  };
  //------------------------------------------------------hacemo el login
  const handleLogin = async (e) => {
    e.preventDefault();
    setCargando(true);
    try {
      //console.log(itemSelected.value);
      let id_peri = itemSelected.value;

      await AuthService.login(email, password, id_peri).then(
        (response) => {
          console.log("AuthService" + response);
          setCargando(false);
          if(response.exito===0){
              
            nuRef.current.show({'type':'info',"text":response.men});
          }else{
            //--correcto el registro  
            //navigate("/dashboard");
            //---------- lo colocamos a el STORE ------------------ 
            //response.user.id_peri = itemSelected.value; //agregamos el periodo al user store
            //response.user.periodo = itemSelected.label; //agregamos el periodo al user store
            dispatch({type: types.authLogin, payload: response.user}); 
            //----------  -----------------------------------------
            console.log("response user")
            console.log(response.user)
            //--- sino esta inscrito a una carrera, no dejar entrar
            if(response.user.id_carre===0 && response.user.id_rol===1){
              alert("Estudiante no inscrito, pase por secretaria de carrera para inscribirse")
              return;
            }

            if(response.user.id_rol===1){ //estudiante
              navigate("/cursos_sel_list");  
            }
            if(response.user.id_rol===2){ //docente
              navigate("/cursosd_sel_list");  
            }
            if(response.user.id_rol===4){ //admin
              navigate("/panel");  
            }
            
          }
          
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    } 
  };

  //----------------------------------------------
  return (
    <div>

      <div id="login">
        <div className="auth-layout-wrap">
          <div className="auth-content" >
            { form.e_logo_horiz!=='' &&
              <img src={ logo_horizontal } alt="Footer Logo" height="120x"/>
            }
            <div className="card" style={{background: "rgba(255,255,255,0.6)" }}>
              
              {/*<div className="card-header ">
                {<h4>Login</h4>}
              </div>
              */}
              
              {
                //JSON.stringify(form)
              }

              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="p-4">

                      {/*<h4 className="mb-3 text-18">ACCESO</h4> */}

                      <span>
                        <form onSubmit={handleLogin}>
                          <span>
                            <fieldset className="form-group text-12">
                              <legend className="bv-no-focus-ring col-form-label pt-0">
                                Email/Username</legend>
                              <div>

                                <input 
                                  type="text" placeholder="" 
                                  className="form-control-rounded form-control"
                                  value={email} 
                                  onChange={(e) => setEmail(e.target.value)}
                                  required
                                  autoComplete={true}
                                />

                              </div>
                            </fieldset>
                          </span>
                          <span>
                            <fieldset className="form-group text-12">
                              <legend className="bv-no-focus-ring col-form-label pt-0">
                                Contraseña</legend>
                              <div>

                                <input 
                                  type="password" placeholder="" 
                                  className="form-control-rounded form-control"
                                  value={password} 
                                  onChange={(e) => setPassword(e.target.value)}
                                  required
                                />
                              </div>
                            </fieldset>
                          </span>

                          <label htmlFor="id_peri">Periodo:</label>
                          
                          <NuDropdown
                            options={ arrPeriodo}
                            name="id_peri"
                            value={ itemSelected.id_peri }
                            onChange={ handleChangePeri }
                          />

                          <button type="submit"
                            className="btn btn-rounded btn-block mt-2 btn-primary mt-2">Ingresar</button>

                        </form>
                      </span>
                      {/*<div className="mt-3 text-center"><a href="/password/reset" className="text-muted"><u>Forgot
                         Password ?</u></a>
                   </div>*/}

                      {/*<button className="btn btn-success m-1" onClick={()=> onClick()} >Success</button>*/}
                      <NuLoading className="oso" show={cargando} text="Cargando..." />
                      <br />
                      <NuAlert2 ref={nuRef} />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Login;